import $ from 'jquery';

export function initSearchBox() {

    $(".dym a").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $form = $(".search-header form");

        const keyword: any = $this.attr("data-keyword");

        $form.find("input[name=q]").val(keyword);
        $form.submit();
    });

}
